import React, { useCallback, useEffect } from "react";
import { Channel, SessionStorageItems, Topic } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { MessageBrokerUtils } from "../../utils";
import PropTypes from "prop-types";
import {
  MenuActionCreators,
  UserContextActionCreators
} from "../../redux/action-creators";
import { UserContextSelectors } from "../../redux/selectors";
import classNames from "classnames";
import { SVGIcon2 } from "../common/SVGIconV2";
import { TrackingInfo } from "../tracking/TrackingInfoHeader";

const Odds = props => {
  const { handleClick } = props;
  const oddsFormat = useSelector(UserContextSelectors.oddsFormat);
  const oddsFormatSettings = useSelector(
    UserContextSelectors.oddsFormatSettings
  );
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const dispatch = useDispatch();

  const setOddsFormat = useCallback(
    code => {
      dispatch(UserContextActionCreators.setOddsFormat(code));
    },
    [dispatch]
  );

  const onClick = code => {
    setOddsFormat(code);
    dispatch(MenuActionCreators.hideOddsMenu());
    MessageBrokerUtils.publish({
      channel: Channel.USER_INTERACTION,
      topic: Topic.oddsFormatUpdate,
      headers: { publisher: "UAA" },
      data: code
    });

    if (typeof handleClick === "function") handleClick();
  };

  useEffect(() => {
    const savedOddsFormat = sessionStorage.getItem(
      SessionStorageItems.OddsFormat
    );
    if (savedOddsFormat && savedOddsFormat !== oddsFormat) {
      setOddsFormat(savedOddsFormat);
    }
  }, [oddsFormat, setOddsFormat]);

  return (
    <ul>
      {oddsFormatSettings?.map(({ code, name }) => {
        const className = classNames({
          "active-odds": oddsFormat === code
        });
        return (
          <OddsListItem
            key={code}
            code={code}
            onClick={onClick}
            className={className}
          >
            <OddsContent text={name} isMobile={isMobile} code={code} />
          </OddsListItem>
        );
      })}
    </ul>
  );
};

Odds.propTypes = {
  handleClick: PropTypes.func
};

const OddsContent = props => {
  const { text, isMobile, code } = props;

  const trackingInfoLocal = TrackingInfo
    ? Object.assign({}, TrackingInfo, { dataLabel: code })
    : Object.assign({}, TrackingInfo, {
        dataCategory: "default",
        dataAction: "click",
        dataLabel: code
      });

  return isMobile ? (
    <a
      data-category={trackingInfoLocal.dataCategory}
      data-action={trackingInfoLocal.dataAction}
      data-label={trackingInfoLocal.dataLabel}
      data-value=""
    >
      <i>
        <SVGIcon2 iconName="check" />
      </i>
      <span className="ellipsis-span">{text}</span>
    </a>
  ) : (
    <a
      data-category={trackingInfoLocal.dataCategory}
      data-action={trackingInfoLocal.dataAction}
      data-label={trackingInfoLocal.dataLabel}
      data-value=""
    >
      <span>{text}</span>
    </a>
  );
};

OddsContent.propTypes = {
  isMobile: PropTypes.bool,
  text: PropTypes.string,
  code: PropTypes.string
};

const OddsListItem = ({ className, code, onClick, children }) => {
  const handleClick = () => {
    onClick(code);
  };

  return (
    <li className={className} onClick={handleClick}>
      {children}
    </li>
  );
};

OddsListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  code: PropTypes.string,
  onClick: PropTypes.func
};

export default React.memo(Odds);
